import { Navigate } from 'react-router-dom';
import { Result, Button } from 'antd';
import { useAuthStore } from '../../stores/authStore';

interface PermissionGuardProps {
  /** 許可するロールのリスト */
  requiredRoles: string[];
  children: React.ReactNode;
  /** 権限がない場合のリダイレクト先（指定しない場合は403画面を表示） */
  redirectTo?: string;
  /** 権限がない場合のタイトル */
  denyTitle?: string;
  /** 権限がない場合のサブタイトル */
  denySubtitle?: string;
}

/**
 * ページレベルの権限制御コンポーネント
 * 権限がない場合は403エラー画面またはリダイレクトを行う
 */
export function PermissionGuard({
  requiredRoles,
  children,
  redirectTo,
  denyTitle,
  denySubtitle,
}: PermissionGuardProps) {
  const { user } = useAuthStore();

  if (!user || !requiredRoles.includes(user.role || '')) {
    if (redirectTo) {
      return <Navigate to={redirectTo} replace />;
    }
    return (
      <Result
        status="403"
        title={denyTitle ?? 'アクセス権限がありません'}
        subTitle={denySubtitle ?? 'このページを表示するには管理者またはマネージャー権限が必要です。'}
        extra={
          <Button type="primary" href="/app">
            ホームに戻る
          </Button>
        }
      />
    );
  }

  return <>{children}</>;
}
